<template>
  <nav class="nav-bar">
    <div class="content">
      <toggle-sidebar></toggle-sidebar>

      <div class="spacerSeparator"></div>

      <user>
        <user-menu>
          <router-link
            :to="{ name: 'Auth-My-Account-Personal-Information' }"
            v-slot="{ href, navigate }"
          >
            <user-menu-item
              @click="navigate"
              :href="href"
              icon="settings-outline"
            >Meus Dados</user-menu-item>
          </router-link>

          <user-menu-item
            href="http://developers.plexi.com.br"
            icon="book-outline"
            target="_blank"
          >Documentação</user-menu-item>

          <router-link
            :to="{ name: 'Auth-Logout' }"
            v-slot="{ href, navigate }"
          >
            <user-menu-item
              @click="navigate"
              :href="href"
              icon="log-out-outline"
            >Sair</user-menu-item>
          </router-link>
        </user-menu>
      </user>
    </div>
  </nav>
</template>

<script>
import { mapState } from 'vuex';
import ToggleSidebar from './navbar/ToggleSidebar.vue';
import User from './navbar/User.vue';
import UserMenu from './navbar/UserMenu.vue';
import UserMenuItem from './navbar/UserMenuItem.vue';

export default {
  name: 'NavBar',

  computed: {
    ...mapState('auth', [
      'user',
    ]),
  },

  components: {
    ToggleSidebar,
    User,
    UserMenu,
    UserMenuItem,
  },
};
</script>

<style lang="scss" scoped>
  nav.nav-bar {
    > .content {
      background: #FFF;
      position: relative;
      display: flex;
      flex: 1 1 auto;
      align-items: center;
      width: 100%;
      height: 64px;
      max-height: 64px;
      min-height: 64px;
      padding: 0 2rem;
      border-bottom: 1px solid #e2e8f0;

      > .spacerSeparator {
        display: flex;
        flex: 1 1 auto;
        height: 1px;
      }
    }
  }
</style>
